/* eslint-disable react/button-has-type */
import React from 'react';
import { BUTTON_TYPE, BUTTON_VER, ButtonInterface } from './buttonTypes';
import './button.scss';
import '../../constants/_global.scss';

const Button: React.FC<ButtonInterface> = ({
  type,
  text,
  ver,
  extraClass,
  disabled,
  onClick,
  customWidth,
}) => {
  const style =
    ver === BUTTON_VER.primary
      ? 'buttonPrimary inButtonText'
      : 'buttonSecondary inButtonText';

  const buttonWidth = {
    maxWidth: customWidth ? `${customWidth}px` : '250px',
  };

  const buttonType = !type ? BUTTON_TYPE.Button : type;

  return (
    <button
      type={buttonType}
      className={`${style} ${extraClass} inButtonText`}
      onClick={onClick}
      disabled={disabled}
      style={buttonWidth}
    >
      {text}
    </button>
  );
};

export default Button;
